document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;

  const rutasLanding = [
    "/pages/molinos",
    "/pages/landing-sanduchera",
    "/pages/landing-sanduchera-espanol",
    "/pages/landing-sanduchera-english"
  ];

  // Ocultar encabezado y footer en páginas específicas
  if (rutasLanding.includes(path)) {
    const elementsToHide = [
      document.querySelector(".top_hdr_wrap"),
      document.querySelector(".tab_brand_selector"),
      document.querySelector("#header"),
      document.querySelector("#shopify-section-footer")
    ];

    elementsToHide.forEach(el => {
      if (el) {
        el.style.setProperty("display", "none", "important");
      }
    });
  }

  // Estilos compartidos para páginas de landing
  if ([
    "/pages/landing-sanduchera",
    "/pages/landing-sanduchera-espanol",
    "/pages/landing-sanduchera-english"
  ].includes(path)) {
    const style = document.createElement("style");
    style.innerHTML = `
      .topSpace {
        display: none !important;
      }

      .layout-boxed {
        max-width: 100% !important;
      }

      .page-width {
        padding: 0px !important;
      }

      .custom-landing-wrapper {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
      }

      @media (max-width: 767px) {
        .custom-landing-wrapper > div:first-child {
          background-position-x: -50px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }
});